module.exports = __webpack_public_path__ + "d4ff4e8869d33477708e7509f6599817.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/LR.svg
// module id = bziC
// module chunks = 0